import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  generalDistrictAll: [],
  generalDistrict: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const generalDistrictSlice = createSlice({
  name: "generalDistrict",
  initialState,
  reducers: {
    setGeneralDistrictAll: (state, action) => {
      state.generalDistrictAll = action.payload;
    },
    setGeneralDistrict: (state, action) => {
      state.generalDistrict = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setGeneralDistrictAll,
  setGeneralDistrict,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = generalDistrictSlice.actions;

export default generalDistrictSlice.reducer;
